import {FilterField, FilterOperator} from "../filter";

export class TextFilterField extends FilterField {

    constructor(key: string, operator: FilterOperator, value?: string|number) {

        super(key, operator);

        if(value !== null && value !== undefined){

            this.value = value;
        }
    }

    get serialize(): string {

        if(this.value === null || this.value === undefined){

            return '';
        }

        return `${this.key}[${this.operator}]=${this.value}`;
    }
}
